/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Pret intreg pentru baxuri (12 sticle la pret de 10): afisam pretul de 12 sticle taiat
// langa pretul baxului, fara sa depindem de "pretul comparat" din Shopify.
(function () {
  function init() {
    if (typeof $ === 'undefined' || typeof Shopify === 'undefined' || !Shopify.formatMoney) return;
    var jsonEl = $('script[id^="ProductJson-"]').first();
    if (!jsonEl.length) return;
    var product;
    try { product = JSON.parse(jsonEl.html() || '{}'); } catch (e) { return; }
    if (!product || !product.variants) return;

    function render(variant) {
      if (!variant) return;
      var priceText = $('.js-product-price-text').first();
      if (!priceText.length) return;
      var isBax = /bax/i.test(variant.title || variant.public_title || '');
      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (!isBax || hasCompare || !(variant.price > 0)) return;
      var full = Math.round(variant.price * 12 / 10);
      var cmp = priceText.find('.js-product-price-compare').first();
      if (!cmp.length) {
        cmp = $('<span class="js-product-price-compare"></span>');
        priceText.append(cmp);
      }
      cmp.html('<s class="product-single__price-compare"><span class="money">' + Shopify.formatMoney(full, theme.money_format) + '</span></s>');
      priceText.find('.product-single__price-number').addClass('product-single__price-number--sale');
    }

    function currentVariant() {
      var id = $('.js-product-variant-select').first().val();
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(id)) return product.variants[i];
      }
      return null;
    }

    document.addEventListener('venue:variant:updated', function (event) {
      render(event.detail && event.detail.variant);
    });

    render(currentVariant());
    setTimeout(function () { render(currentVariant()); }, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
